<template>
  <div class="oido-font-selector" :class="{ disabled, readonly }">
    <label v-if="label">
      <span class="label-text" v-text="label"></span>
      <span class="required-marker" v-if="required"> *</span>
    </label>
    <div class="input-section">
      <div v-if="readonly" class="readonly-value" :style="{ fontFamily: selectedFontFamily }">
        {{ selectedLabel }}
      </div>
      <div v-else class="selector" @click="toggle" :class="{ open }">
        <span class="selected-preview" :style="{ fontFamily: selectedFontFamily }">
          {{ selectedLabel }}
        </span>
        <span class="chevron">&#9662;</span>
      </div>
      <div v-if="open && !readonly && !disabled" class="dropdown">
        <div class="font-option" v-for="(config, key) in fonts" :key="key"
          :class="{ active: modelValue === key }" @click="select(key)">
          <span class="font-option-label">{{ config.label || key }}</span>
          <span class="font-option-preview" :style="{ fontFamily: config.previewFonts }">{{ config.previewText || key }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    fonts: { type: Object, default: () => ({}) },
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
      open: false
    }
  },
  computed: {
    selectedFontFamily() {
      let config = this.modelValue && this.fonts[this.modelValue];
      return config ? config.previewFonts : 'inherit';
    },
    selectedLabel() {
      let config = this.modelValue && this.fonts[this.modelValue];
      return config ? config.label : this.modelValue || '—';
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.open = !this.open;
    },
    select(key) {
      this.$emit('update:modelValue', key);
      this.open = false;
    },
    onClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onClickOutside);
  }
}
</script>

<style scoped>
.oido-font-selector {
  width: 100%;
  position: relative;
  padding-top: 0.7rem;
  padding-bottom: 0.8rem;
  font-size: 0.9rem;
}

label {
  font-weight: 590;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #222;
  margin-bottom: 0.2rem;
}

.input-section {
  position: relative;
}

.selector {
  background-color: #F6F7F9;
  min-height: 2.51rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  user-select: none;
}

.disabled .selector {
  background-color: rgba(0, 0, 0, 0.05);
  color: #444;
  cursor: default;
}

.selected-preview {
  font-weight: 450;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  color: #777;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  transition: transform 0.15s;
}

.selector.open .chevron {
  transform: rotate(180deg);
}

.readonly-value {
  font-weight: 450;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 0.3rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 20rem;
  overflow-y: auto;
}

.font-option {
  padding: 0.5rem 0.7rem;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.font-option:last-child {
  border-bottom: none;
}

.font-option:hover {
  background-color: #F6F7F9;
}

.font-option.active {
  background-color: #EEF2FF;
}

.font-option-label {
  font-size: 0.75rem;
  color: #888;
  font-weight: 590;
  text-transform: capitalize;
}

.font-option-preview {
  font-size: 1.05rem;
  line-height: 1.4;
  color: #222;
}
</style>
